"use strict";

(function () {
  'use strict';

  function OptionCompactCtrl() {
    var vm = this;

    this.add = function (optionId) {
      vm.addOption({
        $event: optionId
      });
    };
  }

  OptionCompactCtrl.$inject = [];
  angular.module('option-compact', []).component('optionCompact', {
    bindings: {
      optionData: '<',
      addOption: '&'
    },
    controller: OptionCompactCtrl,
    templateUrl: 'components/option-compact/option-compact.html'
  });
})();